import {Injectable} from "@angular/core";
import {RouterStateSnapshot, TitleStrategy} from "@angular/router";
import {PageTitleService} from '@app/core/service/pageTitle.service';

@Injectable({providedIn: 'root'})
export class TemplatePageTitleStrategy extends TitleStrategy {
    constructor(private pageTitleService: PageTitleService) {
        super();
    }

    override updateTitle(routerState: RouterStateSnapshot) {
        const pageTitle = this.buildTitle(routerState);
        this.pageTitleService.setTitle(pageTitle, true);
    }
}
